export const iconFontAwesomeCharityDollarSign = (
	<i className="fa-solid fa-dollar-sign"></i>
);
